/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IDesktopGetListRequest, TDesktopGetListModel, IMappers, TDesktopGetListResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetListForDesktopAppsResponseSchema } from '../../../entities/get_list_for_desktop/GetListForDesktopAppsResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createDesktopGetListModel(parameters: IDesktopGetListRequest): TDesktopGetListModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'saved-searches',
    pathApi: '/v1/desktop/get-list/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IDesktopGetListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IDesktopGetListRequest;
}

export async function fetchDesktopGetList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDesktopGetListOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDesktopGetListResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDesktopGetListModel(parameters),
    config,
  )) as FetchResponse<TDesktopGetListResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetListForDesktopAppsResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDesktopGetListResponse>;
}
